/*
  OBSI – brand motion layer. (vormals obsi.js – umbenannt am 06.07.2026,
  weil das Shopify-CDN die alte URL dauerhaft mit einer veralteten Version
  beantwortete. Bei künftigen Cache-Problemen: Datei erneut umbenennen.)
  Lightweight, dependency-free progressive enhancement.
  Honors prefers-reduced-motion and degrades gracefully without JS
  (elements are visible by default unless .obsi-reveal hides them, and
  this script reveals them; if JS is off, see the no-js fallback below).
*/
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // No-JS / reduced-motion safety: make any reveal element visible immediately.
  function revealAllImmediately() {
    document.querySelectorAll('.obsi-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  function initReveal() {
    var els = document.querySelectorAll('.obsi-reveal:not(.is-visible)');
    if (!els.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealAllImmediately();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    els.forEach(function (el) { observer.observe(el); });
  }

  // Fill flag emojis from a 2-letter ISO country code on any [data-obsi-flag].
  // Zero-asset, reusable across sections (matchday, etc.).
  function fillFlags() {
    document.querySelectorAll('[data-obsi-flag][data-cc]:not([data-flagged])').forEach(function (el) {
      var cc = (el.dataset.cc || '').toUpperCase();
      if (cc.length === 2 && /^[A-Z]{2}$/.test(cc)) {
        el.textContent = String.fromCodePoint(127397 + cc.charCodeAt(0), 127397 + cc.charCodeAt(1));
      }
      el.dataset.flagged = '1';
    });
  }

  // Mobile sticky Add-to-Cart: a persistent CTA that triggers the real
  // (variant-aware) product submit button once it scrolls out of view.
  function initStickyAtc() {
    var form = document.querySelector('product-form');
    if (!form || document.querySelector('.obsi-sticky-atc')) return;
    var realBtn = form.querySelector('.product-form__submit');
    var titleEl = document.querySelector('.product__title');
    if (!realBtn || !titleEl) return;

    var bar = document.createElement('div');
    bar.className = 'obsi-sticky-atc';
    bar.innerHTML =
      '<span class="obsi-sticky-atc__title"></span>' +
      '<button type="button" class="obsi-sticky-atc__btn button"></button>';
    document.body.appendChild(bar);

    var btn = bar.querySelector('.obsi-sticky-atc__btn');
    bar.querySelector('.obsi-sticky-atc__title').textContent = (titleEl.textContent || '').trim();

    function syncBtn() {
      var span = realBtn.querySelector('span');
      btn.textContent = ((span ? span.textContent : realBtn.textContent) || 'In den Warenkorb').trim();
      btn.disabled = realBtn.disabled;
    }
    syncBtn();
    btn.addEventListener('click', function () { realBtn.click(); });

    if ('MutationObserver' in window) {
      new MutationObserver(syncBtn).observe(realBtn, { attributes: true, childList: true, subtree: true });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(realBtn);
    }
  }

  function init() {
    initReveal();
    fillFlags();
    // initStickyAtc() deaktiviert: ersetzt durch snippets/obsi-sticky-atc.liquid,
    // das die ECHTEN Kaufbuttons (inkl. Shop Pay) fix am unteren Rand hält.
    // (Diese alte Variante zeigte nur Titel + einen separaten schwarzen Button.)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when sections are re-rendered in the Theme Editor.
  document.addEventListener('shopify:section:load', init);

  // Product lightbox carousel — arrow navigation
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest && e.target.closest('.obsi-lightbox-arrow');
    if (!arrow) return;
    var dialog = arrow.closest('.product-media-modal__dialog');
    var content = dialog && dialog.querySelector('.product-media-modal__content');
    if (!content) return;
    var dir = arrow.classList.contains('obsi-lightbox-arrow--next') ? 1 : -1;
    content.scrollBy({ left: dir * content.clientWidth, behavior: 'smooth' });
  });
})();
